import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import emitter from "@/utils/emitter";
// const lang = localStorage.getItem('lang') || import.meta.env.VITE_LANG || 'en'
const lang = localStorage.getItem('lang')||'unn';//unn表示未设置语言(即首次访问),在main.js中请求接口getLang设置语言
//创建路由器  create a router
const router = createRouter({
  history: createWebHistory(),
  // history: createWebHashHistory(),
  //管理路由 manageRouting
  routes: [//一个个的路由规则
    {
      path: "/",
      // redirect: `/${lang}/box`,//重定向到首页
      redirect:(to)=>{
        localStorage.removeItem("sandbox")
        console.log('redirect to box:',`/${lang}/box`);
        return `/${lang}/box`
      },
      
    },

    {
      path:"/sandbox",
      redirect: `/${lang}/sandbox/box`,//重定向到首页
    },

    //steam授权登录回调地址
    {
      path: '/steamCallback',
      name: 'steamCallback',
      component: () => import('@/components/common/login/SteamCallback.vue')
    },
    // ...其他路由
    {
      path: '/:pathMatch(.*)*', // 通配符匹配所有未定义路径
      redirect: '/en/box'  // 或 redirect: '/' 跳转到首页
    },

    {
      path: "/:lang(zh-CN|en|de|kr|fr|jp|pl|ru|vn|tr|es|pt|br|th|idn|zh-TW|unn)",//动态语言参数   unn表示未设置语言(访问用户自己选择的语言)
      children: [
        {
          path: "sandbox/box",
          name: 'sandbox',
          desc: '首页',
          component: () => import('@/page/box/index.vue')
        },
        {
          path: "box",
          name: 'box',
          desc: '首页',
          component: () => import('@/page/box/index.vue')
        },
        {
          path: "box/:id",
          name: "boxid",
          desc: '盲盒开箱详情页',
          component: () => import('@/page/boxdetail/index.vue')
        },
        {
          path: "play/box/:id",
          name: "playBox",
          desc: '公开 SEO 页面进入开箱流程',
          component: () => import('@/page/boxdetail/index.vue')
        },
        {
          path: "welfarebox/:id",
          name: "welfareboxid",
          desc: '福利箱开箱详情页',//任务+每日等级福利
          component: () => import('@/page/welfareboxdetail/index.vue')
        },
        {
          path: 'upgrade',
          name: 'upgrade',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/upgrade/index.vue')
        },
        {
          path: 'exchange',
          name: 'exchange',
          meta: {
            needLogin: true
          }
          , component: () => import('@/page/exchange/index.vue')
        },
        {
          path: 'battle',
          name: 'battle',
          component: () => import('@/page/battle/index.vue')
        },
        {
          path: 'create',
          name: 'create',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/createbattle/index.vue')
        },
        {
          path: 'broom/:id',
          name: 'battleRoom',
          component: () => import('@/page/battleroom//index.vue')
        },

        // {
        //   path: '/roll',
        //   name: 'roll',
        //   component: () => import('@/page/roll/index.vue'),
        // },
        {
          path: 'roll/:id',
          name: 'rolldetail',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/rolldetail/index.vue'),
        },
        {
          path: 'user',
          name: 'user',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/user/index.vue'),
          children: [{
            path: 'battle',
            component: () => import('@/page/battle/index.vue'),
          }
          ]
        },
        {
          path: 'bank',
          name: 'bank',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/bank/index.vue'),
        },
        {
          path: 'seed/:rollId',
          name: 'seed',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/seedsetting/index.vue'),
        },
        {
          path: 'seed',
          name: 'seedNoRollId',
          meta: {
            needLogin: true
          },
          component: () => import('@/page/seedsetting/index.vue'),
        },
        {
          path: 'mission',
          name: 'mission',
          desc: '任务墙',
          component: () => import('@/page/mission/index.vue'),
        },
        {
          path: 'daily',
          name: 'daily',
          desc: '每日宝箱-等级福利箱',
          component: () => import('@/page/giftcase/index.vue'),
        },
        {
          path: 'roll',
          redirect: (to) => ({
            path: `/${to.params.lang}/daily`,
            query: { roll: true }
          })
        },
        {
          path: 'slogin',
          name: 'slogin',
        },
        {
          path: 'policy/:id',
          // path:'/policy',
          name: 'policy',
          component: () => import('@/page/policy/index.vue')
        },
        {
          path: 'sitemap',
          name: 'sitemap',
          component: () => import('@/page/sitemap/index.vue')
        },
        // {
        //   path: '/test',
        //   name: 'test',
        //   component: () => import('@/page/test/index.vue'),
        // }
      ]
    }

  ],
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },
})


//监听是否未登录
// emitter.on('api:un_auth', (needLogin) => {

//   //未登录 弹登录框或跳到登录页
//   // router.push('/login')


//   // router.beforeEach((to, from, next) => {
//   //   if (to.matched.some(record => record.meta.needLogin)) {
//   //     if (needLogin) {
//   //       next()
//   //     } else {
//   //       next({
//   //         path: '/user',
//   //         query: { redirect: to.fullPath }
//   //       })
//   //     }
//   //   } else {
//   //     next()
//   //   }
//   // })
// })

export default router
